const isResponsiveObject = (v) => typeof v === "object" && v !== null && !Array.isArray(v) && "desktop" in v;
/**
 * Resolve a ResponsiveValue at a given breakpoint. Falls back:
 *   mobile -> tablet -> desktop
 *   tablet -> desktop
 */
export function resolveResponsive(value, breakpoint) {
    if (!isResponsiveObject(value))
        return value;
    if (breakpoint === "mobile") {
        return value.mobile ?? value.tablet ?? value.desktop;
    }
    if (breakpoint === "tablet") {
        return value.tablet ?? value.desktop;
    }
    return value.desktop;
}
//# sourceMappingURL=responsive.js.map